export default class CoursesFilter {
  constructor(c) {
    this.$form = c;
    this.$results = document.getElementById("results");
    this.$noResults = document.getElementById("noResults");
    this.$resultCount = document.getElementById("courseResultCount");
    this.$selectFormat = document.getElementById("format");
    this.$selectState = document.getElementById("state");
    this.$resetFilterBtn = document.querySelector(
      ".results__no-results-button"
    );
    this.$resetFilterBtn.addEventListener("click", this.resetFilter.bind(this));
    this.registerEvents();
  }

  // Handle Filter events
  registerEvents() {
    this.$form.querySelectorAll("select").forEach((select) => {
      // Specifically check for the 'format' filter
      if (select.name === "format") {
        select.addEventListener("change", this.toggleStateFilter.bind(this));
      } else {
        select.addEventListener("change", this.handleFilterChange.bind(this));
      }
    });
  }

  // Call for course results
  async handleFilterChange(event) {
    // Prevent the default form submission if the event is a 'submit' event
    if (event.type === "submit") {
      event.preventDefault();
    }

    event.preventDefault();

    const formData = new FormData(this.$form);
    const queryParams = new URLSearchParams(formData);
    const fetchUrl = `${this.$form.action}?${queryParams.toString()}`;

    const url = new URL(window.location);
    for (const [key, value] of queryParams) {
      if (value !== "") {
        url.searchParams.set(key, value);
      } else if (value === "" && url.searchParams.has(key)) {
        url.searchParams.delete(key);
      }
    }

    // change url params according to selected form state
    window.history.pushState(null, "", url);

    try {
      const response = await fetch(fetchUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const json = await response.json();

      this.updateUI(json);
    } catch (error) {
      this.showError(error);
    }
  }

  // Update UI
  updateUI(json) {
    // Check if 'error' key exists and display the error message.
    if (json.error) {
      this.showAlert(json.error);
      this.$results.innerHTML = "";
      this.$results.style.display = "none";
      this.$noResults.style.display = "block";
      this.$resultCount.innerHTML = 0;
    }
    // Check if 'data' key exists and has values.
    else if (json.data && Object.keys(json.data).length > 0) {
      // Convert object values to an array and join them into a single HTML string.
      const coursesHtml = Object.values(json.data).join("");
      this.$results.innerHTML = coursesHtml;
      this.$results.style.display = "flex";
      this.$noResults.style.display = "none";

      this.$resultCount.innerHTML = json.count;
    }
    // If 'data' is empty or not present, show the 'no results' message.
    else {
      this.$results.innerHTML = "";
      this.$results.style.display = "none";
      this.$noResults.style.display = "block";

      this.$resultCount.innerHTML = 0;
    }
  }

  showAlert(message) {
    console.error("Error:", message);
  }

  showError(error) {
    this.$results.innerHTML = "";
    this.showAlert(error.toString());
    this.$noResults.style.display = "block";
  }

  resetFilter() {
    // Reset the URL query string
    window.history.replaceState({}, document.title, window.location.pathname);
    // Ensure state select is enabled when resetting filters
    this.$selectState.disabled = false;
    // Reset the form
    this.$form.reset();
    // Reset all select fields
    const selects = this.$form.querySelectorAll("select");
    selects.forEach((select) => {
      select.selectedIndex = 0;
    });
    // Reset the UI
    this.$results.innerHTML = "";
    this.$noResults.style.display = "none";
    this.handleFilterChange(new Event("reset"));
  }

  // Disable the state filter if the format is "onlinekurse"
  toggleStateFilter() {
    if (
      this.$selectFormat.value === "onlinekurse" ||
      this.$selectFormat.value === "blended-learning-onlinekurse"
    ) {
      this.$selectState.selectedIndex = 0;
      this.$selectState.disabled = true;
    } else {
      this.$selectState.disabled = false;
    }
    this.handleFilterChange(new Event("init"));
  }
}
